'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Point = require('./Point');

var _Point2 = _interopRequireDefault(_Point);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Triangle = function () {
  function Triangle(_ref) {
    var initialPoint = _ref.initialPoint,
        width = _ref.width,
        gradient = _ref.gradient,
        darkColor = _ref.darkColor,
        lightColor = _ref.lightColor;

    _classCallCheck(this, Triangle);

    this.initialPoint = initialPoint;
    this.width = width;
    this.gradient = gradient;
    this.darkColor = darkColor;
    this.lightColor = lightColor;
    this.color = gradient.randomGray(initialPoint.x, initialPoint.y);
    this.getPoints();
  }

  _createClass(Triangle, [{
    key: 'getPoints',
    value: function getPoints() {
      var initialPoint = this.initialPoint,
          width = this.width;

      var points = [];

      switch (this.type) {
        case 1:
          points.push(initialPoint);
          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
          points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
          break;
        case 2:
          points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
          points.push(new _Point2.default(points[0].x + width, points[0].y - width));
          points.push(new _Point2.default(points[0].x + width, points[0].y));
          break;
        case 3:
          points.push(initialPoint);
          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y + width));
          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
          break;
        default:
          points.push(initialPoint);
          points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
          break;
      }

      this.points = points;
      return points;
    }
  }, {
    key: 'draw',
    value: function draw(ctx) {
      var color = this.color,
          points = this.points;

      ctx.fillStyle = color;
      if (color.toString().indexOf('NaN') >= 0) {
        return;
      }
      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      ctx.lineTo(points[1].x, points[1].y);
      ctx.lineTo(points[2].x, points[2].y);
      ctx.lineTo(points[0].x, points[0].y);
      ctx.closePath();
      ctx.fill();
      return this;
    }
  }, {
    key: 'redraw',
    value: function redraw(ctx) {
      var colored = this.colored,
          initialPoint = this.initialPoint,
          darkColor = this.darkColor,
          lightColor = this.lightColor,
          width = this.width;


      this.type = Math.floor(Math.random() * 4);
      var points = this.getPoints();

      if (colored) {
        switch (this.type) {
          case 1:
            points.push(initialPoint);
            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
            points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
            break;
          case 2:
            points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
            points.push(new _Point2.default(points[0].x + width, points[0].y - width));
            points.push(new _Point2.default(points[0].x + width, points[0].y));
            break;
          case 3:
            points.push(initialPoint);
            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y + width));
            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
            break;
          default:
            points.push(initialPoint);
            points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
            break;
        }
        this.color = ctx.createLinearGradient(initialPoint.x, initialPoint.y, initialPoint.x + width, initialPoint.y + width);
        this.color.addColorStop(0, darkColor);
        this.color.addColorStop(1, lightColor);
      } else {
        this.color = this.gradient.randomGray(initialPoint.x, initialPoint.y);
      }

      return this.draw(ctx);
    }
  }, {
    key: 'init',
    value: function init(ctx) {
      var initialPoint = this.initialPoint,
          gradient = this.gradient;

      var types = [1, 2, 3, 4];

      while (types.length > 1) {
        this.type = types.splice(Math.floor(Math.random() * types.length), 1)[0];
        this.color = gradient.randomGray(initialPoint.x, initialPoint.y);
        this.getPoints();
        this.draw(ctx);
      }

      this.color = gradient.randomGray(initialPoint.x, initialPoint.y);
      this.type = types.pop();
      this.getPoints();

      this.draw(ctx);

      return this;
    }
  }, {
    key: 'colorRedraw',
    value: function colorRedraw() {
      this.colored = true;
      return this;
    }
  }, {
    key: 'grayRedraw',
    value: function grayRedraw(ctx) {
      this.colored = false;
      this.init(ctx);
      return this.init(ctx);
    }
  }]);

  return Triangle;
}();

exports.default = Triangle;


//////////////////
// WEBPACK FOOTER
// ./~/triangles-canvas/dist/Triangle.js
// module id = 437
// module chunks = 35783957827783